// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2qYSm","file":"styles_file__1QhKx"};